export default __webpack_public_path__ + "static/media/CoT_logo_RGB.85ddaff4.svg";